import React from 'react';
import PlacementExport from 'components/Placement/Export/Export';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function ScreensPlacementsExport() {
  return (
    <div className="base-layout__content">
      <DocumentTitle>Placements Export</DocumentTitle>
      <PlacementExport />
    </div>
  );
}

export default ScreensPlacementsExport;
